// extracted by mini-css-extract-plugin
module.exports = {"svg":"Loading_svg___z_5_","text-copy":"Loading_text-copy__ORVqy","stroke-offset":"Loading_stroke-offset__YMpY4"};